/**
 * 接口每日用量请求统计组件
 */

import { useEffect, useState } from 'react';
import {
    Row,
    Col,
    message,
    DatePicker,
} from 'antd';
import { Chart } from '@antv/g2';
import $ from 'jquery';
import {
    UjoinParams,
    AddRequestHeaders,
    winWidth,
    NumberToMillionFormat,
    CurrentDateBeforeDays,
    currentDate,
    isGTscreenWidth,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

/** 
* 日期样式
*/
import locale from 'antd/es/date-picker/locale/zh_CN';
const { RangePicker } = DatePicker;

const LogTRCD = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    const [startDate, setStartDate] = useState(CurrentDateBeforeDays(365));
    const [endDate, setEndDate] = useState(currentDate);

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh) {
                // 获取数据
                const params = {
                    'start_date': startDate,
                    'end_date': endDate,
                }
                $.ajax({
                    url: `${CNF.api}reports/log/ttcd${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            setData(data.dat);
                            setIsRefresh(false);
                        } else {
                            messageApi.error(data.msg, CNF.messageDuration);
                        }
                    }
                })
            }
        }
    }, [startDate, endDate]);

    useEffect(() => {
        const chart = new Chart({
            width: winWidth - (props.collapsed ? 80 : 200) - 50,
            container: 'antv-g2-id',
            autoFit: true,
        });

        chart.title({
            title: '接口每日用量统计',
            subtitle: '展示指定日期内(默认365天)接口每日用量按输入、输出和总计统计。',
        });

        chart.data(data);

        chart
            .encode('x', 'date')
            .encode('y', 'count')
            .encode('color', 'type')
            .encode('shape', 'smooth')
            .axis('x', { title: false })
            .axis('y', { title: false })
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .transform({ type: 'stackEnter', groupBy: 'color', duration: CNF.animateDuration })
            .transform({ type: 'stackY', orderBy: 'value' })
            .animate('enter', { type: 'growInX' })
            .axis('x', { title: '日期', })
            .axis('y', { title: '', labelFormatter: (d) => NumberToMillionFormat(d) });


        chart.area().style('fillOpacity', 0.8).tooltip(false);
        chart.line().style('strokeWidth', 1).tooltip({
            items: [
                { channel: 'y', valueFormatter: (d) => `${NumberToMillionFormat(d)}`, },
            ],
        });

        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props, data]);

    return <>
        {contextHolder}
        {
            props.data ? '' : <Row style={{ margin: '15px 0 0 15px' }}>
                <Col span={isGTscreenWidth ? 5 : 6} style={{ marginLeft: CNF.searchMarginLeft, }}>
                    <RangePicker
                        placeholder={['开始日期', '结束日期']}
                        style={{ width: '100%' }}
                        format='YYYY-MM-DD'
                        locale={locale}
                        onChange={(_, dateString) => {
                            setStartDate(dateString[0] ? dateString[0] : CurrentDateBeforeDays(365));
                            setEndDate(dateString[1] ? dateString[1] : currentDate);
                            setIsRefresh(true);
                        }}
                    />
                </Col>
            </Row>
        }
        <div id='antv-g2-id'></div>
    </>
}

export default LogTRCD;